import * as React from "react";

// Mobile-first: Mobile is default, desktop starts at 768px (Tailwind's 'md' breakpoint)
const MOBILE_BREAKPOINT = 768;

function readIsMobile(): boolean {
  // Vite SPA only; keep a desktop default for any non-browser eval path.
  if (typeof window === "undefined") return false;
  return window.innerWidth < MOBILE_BREAKPOINT;
}

/**
 * Sync initial state with the viewport so the first paint does not assume
 * desktop (`!!undefined === false`) and then flip to a mobile Sheet.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(readIsMobile);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    // Re-sync after mount (orientation / resize that beat the first paint).
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
